"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDealer = void 0;
const card_id_1 = require("../card/card-id");
const logic_metrics_1 = require("../logic-metrics");
const shuffler_1 = require("../../../common/shuffler");
class LocalDealer {
    constructor(secrets) {
        this.secrets = secrets;
        this.indexToHash = new Map();
    }
    static makeRandom(localSeed) {
        const deck = LocalDealer.generateDeck();
        const seed = localSeed
            ? localSeed
            : Math.floor(new Date().getTime() / 1000);
        const cards = shuffler_1.Shuffler.shuffledDeck(seed, Array.from(deck));
        console.log(`Shuffling with seed: ${seed}`);
        const fixedIds = [];
        const fixedIdsRaw = fixedIds.map((id) => new card_id_1.CardId(id).rawId);
        const replacementStartIndex = cards.length - fixedIds.length;
        const stackedIds = [
            ...cards.slice(0, replacementStartIndex),
            ...fixedIdsRaw,
        ];
        return new LocalDealer([...stackedIds]);
    }
    discloseSecrets(indexes, gameHash) {
        try {
            for (const index of indexes) {
                if (!this.indexToHash.has(index)) {
                    this.indexToHash.set(index, gameHash);
                }
            }
            return Promise.resolve(indexes.map((index) => new card_id_1.CardId(this.secrets[index]).id));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    attestation() {
        const secrets = this.secrets;
        return {
            secrets: this.secrets.map((value, index) => ({
                value,
                index,
            })),
            disclosures: Array.from(this.indexToHash).map((entry) => ({
                index: entry[0],
                hash: entry[1],
                value: secrets[entry[0]],
            })),
        };
    }
    static generateDeck() {
        const deck = Array.from(Array(logic_metrics_1.LogicMetrics.DeckCards + logic_metrics_1.LogicMetrics.WildCards).keys());
        // 4 aces + 2 wildcards
        const requiredCards = [0, 13, 26, 39, 52, 53];
        const cardsToDelete = 2;
        for (let i = 0; i < cardsToDelete; i++) {
            const indexToRemove = deck.findIndex((card) => !requiredCards.includes(card));
            deck.splice(indexToRemove, 1);
        }
        return deck;
    }
}
exports.LocalDealer = LocalDealer;
